import * as React from 'react'

const SvgArrowDownLeftIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.75 16.25V15H5.881L16.25 4.631l-.881-.881L5 14.119V6.25H3.75v10h10z"
      fill="#163250"
    />
  </svg>
)

export default SvgArrowDownLeftIcon
